import {
  appHealthDataFetchPath,
  appInfoDataFetchPath,
  appStartupInfoFetchPath,
  auditLoginEventsFetchPath,
  httpTraceFetchPath,
} from '../constants/apiEndpoints';
import { serverHealthStatus } from '../constants/globals';
import { adminPanelActions } from '../reducers/adminPanel';
import { tokenExpiredAction } from '../utils/actions';
import apiService from '../utils/apiService';

export const fetchDataForAdminPanel = () => {
  return (dispatch) => {
    dispatch(adminPanelActions.actionStart());
    return apiService
      .get(appInfoDataFetchPath())
      .then((response) => {
        dispatch(adminPanelActions.setInfoData(response?.data));
      })
      .then(() => apiService.get(appStartupInfoFetchPath()))
      .then((response) => {
        dispatch(
          adminPanelActions.setStartupInfoData(
            response?.data?.measurements?.[0]?.value
          )
        );
      })
      .then(() => apiService.get(appHealthDataFetchPath()))
      .then((response) => {
        dispatch(adminPanelActions.setHealthData(response.data));
      })
      .catch((err) => {
        dispatch(adminPanelActions.setServerStatus(serverHealthStatus.DOWN));
      });
  };
};

export const reset = () => {
  return (dispatch) => dispatch(adminPanelActions.reset());
};

export const fetchAuditLoginEvents = () => {
  return (dispatch) => {
    dispatch(adminPanelActions.actionStart());
    return apiService
      .get(auditLoginEventsFetchPath())
      .then((response) => {
        dispatch(
          adminPanelActions.fetchAuditLoginEvents(response?.data?.events)
        );
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          tokenExpiredAction();
        } else dispatch(adminPanelActions.actionError(err?.response?.data));
      });
  };
};

export const fetchHttpTraces = () => {
  return (dispatch) => {
    dispatch(adminPanelActions.actionStart());
    return apiService
      .get(httpTraceFetchPath())
      .then((response) => {
        dispatch(adminPanelActions.fetchHttpTraces(response?.data?.traces));
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          tokenExpiredAction();
        } else dispatch(adminPanelActions.actionError(err?.response?.data));
      });
  };
};
